module.exports = __webpack_public_path__ + "static/img/info_p.93044cfa.svg";